import {IWatcher, EWatcherFieldFlag} from '../../hooks/use-form-fields-manager';

export const createReportConfiguratorWatchers = ({
    isEditingForm,
    valuesReferenceUrls,
}: {
    isEditingForm: boolean;
    valuesReferenceUrls: {[index: string]: string | undefined | null};
}) => ({
    paginationSheetCode: [{
        condition: ({formValues}) => formValues.enabledMenu,
        flag: EWatcherFieldFlag.isRequired,
    }],
    buttonPaginationSettings: [{
        isNotInput: true,
        condition: () => false,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonHeaderSettings: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledMenu,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledDownloadBtn: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledDownloadBtn,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledGroupingSettingsBtn: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledGroupingSettingsBtn,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledSelectAllRowsBtn: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledSelectAllRowsBtn,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledDetailedSummaryBtn: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledDetailedSummaryBtn,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonActionsEnabled: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.actionsEnabled,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledCrSettings: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledCr,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    buttonEnabledComparison: [{
        isNotInput: true,
        condition: ({formValues}) => !formValues.enabledComparison,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    tableDatasourceSqlValue: [{
        condition: ({formValues}) => formValues.tableDatasourceType !== 'SQL',
        flag: EWatcherFieldFlag.isHidden,
    },
    {
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    headerDatasourceSqlValue: [{
        condition: ({formValues}) => formValues.headerDatasourceType !== 'SQL',
        flag: EWatcherFieldFlag.isHidden,
    },
    {
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    }],
    tableDatasourceValue: [{
        condition: ({formValues}) => formValues.tableDatasourceType === 'SQL'
                || !formValues.tableDatasourceType,
        flag: EWatcherFieldFlag.isHidden,
    },
    {
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    },
    {
        condition: () => !valuesReferenceUrls.tableDatasourceValue,
        flag: EWatcherFieldFlag.isLoading,
    }],
    headerDatasourceValue: [{
        condition: ({formValues}) => formValues.headerDatasourceType === 'SQL'
                || !formValues.headerDatasourceType,
        flag: EWatcherFieldFlag.isHidden,
    },
    {
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    },
    {
        condition: () => !valuesReferenceUrls.headerDatasourceValue,
        flag: EWatcherFieldFlag.isLoading,
    }],
    // ---
    ...(() => Object.fromEntries([
        'templateName',
        'templateCode',
        'reportName',
        'designTemplate',
        'paginationPosition',
        'enabledMenu',
        'withDocumentId',
        'enabledComparisonBtn',
        'enabledCrBtn',
        'enabledColumnsSettingsBtn',
        'enabledRefreshBtn',
        'enabledSearch',
        'enabledDownloadBtn',
        'enabledAttachmentsBtn',
        'enabledGroupingSettingsBtn',
        'enabledSelectAllRowsBtn',
        'enabledDetailedSummaryBtn',
        'actionsEnabled',
        'tableDatasourceType',
        'headerDatasourceType',
        'enabledRowComments',
        'enabledRowAttachments',
        'enabledRowRequests',
        'enabledComparison',
        'enabledCr',
        'enabledColumnTitleOrdinals',
        'enabledPrint',
        'enabledViewControlRatioBtn',
        'enabledDrillUpBtn',
        'enabledMenuWhenUsingDrillFilter',
        'enabledEnabledPreExecution',
        'enabledRecordsInfo',
    ].map(fieldName => [fieldName, [{
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    }]])))(),
} as {[index: string]: IWatcher[]});
